module.exports = __webpack_public_path__ + "img/3_香港1(1).232ae429.jpg";